import { Action } from 'redux';
import { Expenses, Pagination } from 'src/types/model';

export interface ItemCategoryState {
  loading: boolean;
  data: Expenses[];
  error: string | null;
}

export const FETCH_EXPENSES_REQUEST = 'FETCH_EXPENSES_REQUEST';
export const FETCH_EXPENSES_SUCCESS = 'FETCH_EXPENSES_SUCCESS';
export const FETCH_EXPENSES_FAILURE = 'FETCH_EXPENSES_FAILURE';

export interface FetchExpensesRequestAction
  extends Action<typeof FETCH_EXPENSES_REQUEST> {}

export interface FetchExpensesSuccessAction
  extends Action<typeof FETCH_EXPENSES_SUCCESS> {
  payload: {
    data: Expenses[];
    pagination: Pagination;
    expensesTotal: number;
  };
}

export interface FetchExpensesFailureAction
  extends Action<typeof FETCH_EXPENSES_FAILURE> {
  payload: string;
}

export type ExpensesActionType =
  | FetchExpensesRequestAction
  | FetchExpensesSuccessAction
  | FetchExpensesFailureAction;
